import dayjs from 'dayjs';
import type { PdpDetailsRow } from '#lib/features/pdp/components/PdpDetails/index.js';
import type { ShopPdpBook } from '#lib/websites/shop/pages/ShopBookPdp/types.js';
import { capitalizeFirstLetters } from '$global/utils/capitalizeFirstLetters';

export const getDetailsRows = (
	book: ShopPdpBook,
	series?: { title?: string | null } | null
): PdpDetailsRow[] => {
	return [
		{
			label: 'Publication',
			value: dayjs(book?.publication_date).format('MMMM YYYY'),
		},
		{ label: 'Illustrations', value: book?.number_of_illustrations || '' },
		...(series?.title ? [{ label: 'Series', value: series.title }] : []),
		{
			label: 'Dimensions',
			value: `${book?.height_mm || 0} x ${book?.width_mm || 0} mm`,
		},
		{ label: 'Format', value: capitalizeFirstLetters(book?.format || '') },
		{ label: 'ISBN', value: book?.isbn || '' },
		{ label: 'No. of pages', value: book?.number_of_pages || '' },
	];
};
